import React from 'react';
import axios from 'axios';
import Navbar from '../Navbar';
import Footer from '../Footer';
import {
    WORDPRESS_URL,
    WP_CATEGORIES_SLUG,
    WP_POST_CATEGORIES_WITH_FEATUREDMEDIA
} from "../../utils/constants";
import Preloader from "../Preloader";
import renderHTML from "react-render-html";
import { Link, Redirect } from "react-router-dom";
import defaultBg from "../../images/category-clanek.jpg";

class TileFourth extends React.Component{

    constructor(props){
        super(props);

        this.state = {
            isLoading: true,
            actualitiesArray: [],
            error: {},
            redirectInternalError: false
        }
    }


    handleBack = () => {
        const { history } = this.props;
        if (document.referrer && document.referrer.includes(window.location.hostname)) {
          history.goBack();
        } else {
          history.push('/'); // nebo jiná stránka
        }
      };

    componentDidMount(){
        axios.get( WORDPRESS_URL + WP_CATEGORIES_SLUG + "zakazkove-obrabeni")
        .then(response_slug => {
            if (response_slug !== undefined) {
                axios.get( WORDPRESS_URL + WP_POST_CATEGORIES_WITH_FEATUREDMEDIA + response_slug.data[0].id + '&per_page=100')
                .then(response_actualities => {
                    if (response_actualities !== undefined) {
                        const actualitiesArray = response_actualities.data.map(function (data, id){
                            let featuredMediaLinks = data._embedded['wp:featuredmedia'] ? data._embedded['wp:featuredmedia'] : null;
                            let featuredMediaLink = featuredMediaLinks ? `url("${featuredMediaLinks[0].source_url}")` : `url("${defaultBg}")`; //rest api na získání úvodního obrázku
                            return {
                                idx: id,
                                title: data.title.rendered,
                                text: data.content.rendered, 
                                shortText: data.excerpt.rendered,
                                slug: data.slug,
                                featuredMedia: featuredMediaLink
                            };
                        });
        
                        this.setState({
                            isLoading: false, 
                            actualitiesArray: actualitiesArray
                        }); 
                    }                     
                });
            }                                   
        })
        .catch( error => {
            console.log(error);  

            this.setState({ 
                error: error, 
                isLoading: false,
                redirectInternalError: true
            });       
        });
    }


    renderHeader = () => {
        return(
            <header className="zo-header section-header">
                <div className="header-overlay">
                <Navbar/>
    
                <div className="sd-container">
                    <section id="section-sub-header">
                            <div className="col-md-12 d-flex justify-content-between section-title"> 
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h6 className="sub-header-caption text-uppercase title-border-radius link">Zakázkové obrábění</h6>
                                    </div>
                                <span className='back-button link' onClick={this.handleBack}><i className='fa ml-2 fa-chevron-left'></i> Zpět</span>          
                            </div>                        
                    </section>
                </div>
                </div>
            </header> 
    );
}
 
    renderMainContainer = () => {
        return(
            <section id="main-container" className='mb-4'>
                                <div className='sd-container'>
                    <section id="section-text">
                    Na základě specifických požadavků zákazníků provádíme opracování materiálů různých jakostí a druhů - kovy, plasty, kompozity, různými metodami, frézování, soustružení, vrtání, či broušení pro dosažení vysokých přesností za použít našich velkých stolových vyvrtávaček (horizontek), frézek, brusek a CNC obráběcích center. Jsme schopni obrábět jednotlivé kusy, malé série i velké série dílů.
                    </section>
                </div>
                <div className="sd-container-aktuality category">
                    <div className="d-flex sd-container-aktuality-flex sd-container-category">
                        <div>
                        {this.renderArticles()} 
                        </div>                       
                    </div>
                </div>
            </section>
        );
    }
    
    renderArticles = () => {
        const { actualitiesArray } = this.state;
    
        const actualities = actualitiesArray.map((actuality, index) =>
            <Link to={`clanek/${actuality.slug}`}>
                            <div className="sd-category-article" key={index}>
                <div className="sd-category-article-image" style={{backgroundImage: actuality.featuredMedia }}>
            </div>
                    <div className="sd-category-article-body">
                        <div className="sd-article-title">{ renderHTML(actuality.title) }</div>
                        <div className="sd-article-content">{ renderHTML(actuality.shortText) }</div>
                        
                        <div className="sd-article-link"> 
                            <span className="pull-right sd-text-primary">
                                <b>Zjistit více</b>
                                <i className="fa fa-chevron-right ml-2"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </Link>
        );
    
        return actualities;
    }
    
    renderFooter = () => {
        return(
            <footer className="footer-section-height">
                <div className="sd-container">
                    <section id="footer-content" className="footer-top-padding footer-top-padding-contact">
                        <Footer/>
                    </section>
                </div>
            </footer>       
        );
    }

    render(){
        const { isLoading, redirectInternalError, error } = this.state;

        return (            
            <section id="web">
                {isLoading ? (
                    <Preloader isLoaded={!isLoading} />
                ) : (redirectInternalError ? (
                    <Redirect to={{
                        pathname: "/500",
                        state: { error: error }
                      }} />
                ) : ( 
                    <div className="wrapper">
                        {this.renderHeader()}

                        {this.renderMainContainer()}

                        {this.renderFooter()}
                    </div>
                ))}
            </section>        
        )
    }
}

export default TileFourth;